import { render, staticRenderFns } from "./navbars.vue?vue&type=template&id=912d67ae&scoped=true&"
import script from "./navbars.vue?vue&type=script&lang=js&"
export * from "./navbars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912d67ae",
  null
  
)

export default component.exports